module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_CN.d613138a.webp";